import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input } from 'antd';
import s from './Password.pcss';


class Password extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    form: PropTypes.shape().isRequired,
    validateMessage: PropTypes.string,
    fieldName: PropTypes.string,
    repeated: PropTypes.bool,
  };
  static defaultProps = {
    placeholder: '',
    form: {},
    validateMessage: 'Please enter your password!',
    fieldName: 'password',
    repeated: false,
  };
  state = {
    showPassword: false,
  };
  toggleShowPassword = () => this.setState({
    showPassword: !this.state.showPassword,
  });

  render() {
    const rules = [
      {
        required: true,
        message: this.props.validateMessage,
      },
    ];
    // it works only for form having field attr name = "password",
    const updatedRules = this.props.repeated ? [...rules, {
      validator: (rule, value, cb) => (
        this.props.form.getFieldsValue().password === value ?
          cb() :
          cb(new Error())),
      message: 'Пароли не совпадают!',
    }] : rules;

    return this.props.form.getFieldDecorator(this.props.fieldName, {
      rules: updatedRules,
    })(
      <div className={s.container}>
        <Input
          className={s.input}
          type={this.state.showPassword ? 'text' : 'password'}
          placeholder={this.props.placeholder}
        />
        <b
          className={s.toggle}
          onClick={this.toggleShowPassword}
        >
          {this.state.showPassword ? 'Скрыть' : 'Показать'}
        </b>
      </div>,
    );
  }
}

export default Password;



// WEBPACK FOOTER //
// ./src/shared/components/Password/Password.js